export const RPMComingSoon = (function() {
	'use strict';

	// Site sits behind Pantheon full-page caching, so the random image is chosen
	// in the browser per page-load instead of being baked into the cached HTML.
	const RANDOMIZE_IN_JS = true;

	// Matches the targetable position classes (rpm-top-left … rpm-bottom-right).
	const POS_CLASS_RE = /^rpm-(top|center|bottom)-(left|center|right)$/;

	function init() {
		const blocks = document.querySelectorAll('.rpmblock--coming-soon');
		blocks.forEach(setup);
	}

	function setup(block) {
		const bg = block.querySelector('.rpmblock--coming-soon__bg');
		if (!bg) return;

		if (RANDOMIZE_IN_JS) {
			const images = parseImages(block);
			if (images.length) {
				const pick = images[Math.floor(Math.random() * images.length)];
				// All custom props live on the block element (PHP writes them
				// there); __bg/__content inherit them. Override before reveal so
				// the content fades in already in the right position (no jump).
				block.style.setProperty('--cs-bg', `url(${pick.d})`);
				block.style.setProperty('--cs-bg-mobile', `url(${pick.m || pick.d})`);
				if (pick.ai) block.style.setProperty('--cs-align', pick.ai);
				if (pick.jc) block.style.setProperty('--cs-justify', pick.jc);

				// Swap the targetable position class to match the picked image
				// (e.g. rpm-top-left). Remove any prior rpm-<pos> class first.
				if (pick.pos) {
					Array.from(block.classList)
						.filter((c) => POS_CLASS_RE.test(c))
						.forEach((c) => block.classList.remove(c));
					block.classList.add('rpm-' + pick.pos);
				}
			}
		}

		// Fade in once the chosen image has actually loaded (content follows a
		// beat later via CSS transition-delay). Read the *resolved* background so
		// the media-query (desktop vs mobile) choice is respected.
		const url = extractUrl(getComputedStyle(bg).backgroundImage);
		if (!url) {
			block.classList.add('is-loaded');
			return;
		}

		const img = new Image();
		img.onload = () => block.classList.add('is-loaded');
		img.onerror = () => block.classList.add('is-loaded');
		img.src = url;
	}

	function parseImages(block) {
		try {
			return JSON.parse(block.dataset.images || '[]');
		} catch (e) {
			return [];
		}
	}

	function extractUrl(value) {
		const match = /url\(["']?(.*?)["']?\)/.exec(value || '');
		return match ? match[1] : '';
	}

	return {
		init: init
	};
})();
